<template>
    <div class="list-wrapper" v-if="imgUrl">
        <div class="img-wrapper">
            <img :src="imgUrl" alt="">
        </div>
        <div class="info">
            <div class="video-name">{{name.replace(/#/g, '')}}</div>
            <div class="tiem">时间：{{startTime | formateDate }}</div>
            <div class="view-num">播放：{{viewerCount}}</div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            imgUrl: {
                type: String
            },
            name: {
                type: String
            },
            startTime: {
                type: String
            },
            viewerCount: {
                type: Number
            }
        },
        filters: {
            formateDate(date) {
                if (date) {
                    return date.split(' ')[0];
                }
                return null;
            }
        }
    }
</script>

<style scoped>
.list-wrapper {
    display: flex;
    padding: 16px;
    align-items: center;
}
.img-wrapper {
    width: 3rem;
    height: 2rem;
}
.img-wrapper img {
    width: 100%;
}
.info {
    margin-left: 16px;
    text-align: left;
    font-size: 14px;
}
</style>